formatValueProps